import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '../components/SectionHeading';
import CTAButton from '../components/CTAButton';
import { OUR_LIVE_SOLUTIONS, LIVE_PLATFORMS_SUMMARY } from '../constant/data';

const ALL = 'All';
const CATEGORIES = [ALL, ...Array.from(new Set(OUR_LIVE_SOLUTIONS.map(s => s.label)))];

function PortfolioCard({ sys }) {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="portfolio-card">

        <div className="portfolio-card-head">
          <div className="portfolio-card-head-top">
            <span className="portfolio-num">PROJECT {sys.num}</span>
            <div className="portfolio-icon"><i className={sys.icon} /></div>
          </div>
          <div className="portfolio-label-badge">{sys.label}</div>
          {sys.liveUrl && (
            <a
              href={sys.liveUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-live-pill"
            >
              <span className="portfolio-live-dot" />
              Live
            </a>
          )}
        </div>

        <div className="portfolio-card-body">
          <h3 className="portfolio-title">{sys.name}</h3>
          <p className="portfolio-tagline">{sys.tagline}</p>
          <p className="portfolio-desc">{sys.description}</p>

          <ul className="portfolio-features">
            {sys.features.slice(0, 3).map(f => (
              <li key={f}>
                <i className="fas fa-arrow-right" />
                {f}
              </li>
            ))}
          </ul>

          <div className="sector-chips" style={{ marginBottom: 0 }}>
            {sys.sectors.map(s => <span key={s} className="sector-chip">{s}</span>)}
          </div>

          <div className="portfolio-actions">
            <Link to={sys.ctaTo} className="portfolio-btn-primary">{sys.ctaLabel}</Link>
            {sys.liveUrl && (
              <a
                href={sys.liveUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="portfolio-btn-ghost"
              >
                <i className="fas fa-arrow-up-right-from-square" />
                {sys.liveLabel}
              </a>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

function Portfolio() {
  const [active, setActive] = useState(ALL);
  const filtered = active === ALL ? OUR_LIVE_SOLUTIONS : OUR_LIVE_SOLUTIONS.filter(s => s.label === active);

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb-nav">
            <Link to="/">Home</Link>
            <span>/</span>
            Portfolio
          </div>
          <h1>Our Portfolio</h1>
          <p>
            Live platforms built and maintained by our team — deployed across Uganda,
            Kenya, Tanzania, and Rwanda.
          </p>
        </div>
      </section>

      <div style={{ background: 'var(--surface-2)', borderBottom: '1px solid var(--border-1)', padding: '2rem 0' }}>
        <div className="container">
          <div className="row g-3 text-center">
            {LIVE_PLATFORMS_SUMMARY.map(s => (
              <div className="col-6 col-md-3" key={s.label}>
                <div className="feature-item">
                  <span className="feature-num">{s.value}</span>
                  <span className="feature-label">{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Visual intro */}
      <section className="section-corporate" style={{ paddingBottom: '1rem' }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <SectionHeading label="Real Work, Real Users">
                Platforms people rely on every day
              </SectionHeading>
              <p style={{ color: 'var(--ink-2)', lineHeight: '1.8', fontSize: '0.95rem', marginBottom: '1.5rem' }}>
                Every project here is live and in active use — not a prototype, not a showcase build.
                Real organisations across East Africa are running on these systems right now.
                That's the standard we hold ourselves to.
              </p>
              <CTAButton type="gold" to="/contact">Start a Project</CTAButton>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <img
                src="/assets/images/portifolio.jpg"
                alt="Salama Consult portfolio"
                style={{
                  width: '100%',
                  height: 340,
                  objectFit: 'cover',
                  borderRadius: 'var(--radius)',
                  boxShadow: 'var(--shadow-md)',
                  display: 'block',
                }}
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section-corporate">
        <div className="container">
          <SectionHeading
            align="center"
            label="Track Record"
            subtitle="Filter by industry or browse everything we've shipped."
          >
            Deployed Projects
          </SectionHeading>

          <div className="portfolio-filters">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                className={`portfolio-filter-btn${active === cat ? ' active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="row g-4">
            {filtered.map(sys => (
              <PortfolioCard key={sys.name} sys={sys} />
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container text-center position-relative">
          <h2>Want something like this?</h2>
          <p>
            Tell us what you're building and we'll put the right team on it — no obligation.
          </p>
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            <CTAButton type="gold"          to="/contact">Start a Project</CTAButton>
            <CTAButton type="outline-light" to="/services">See Our Services</CTAButton>
          </div>
        </div>
      </section>
    </>
  );
}

export default Portfolio;
